import { makeAutoObservable } from 'mobx'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'
import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  STIPE_ELEMENT_OPTIONS_DEFAULT,
  TWINT_COUNTRIES,
} from 'constants/paymentSettingShared.constants'

import {
  StripeElementsPayloads,
  StripePaymentElement,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopTwintPaymentMethodStore implements StripePaymentElement {
  storeName = 'ShopTwintPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAvailable = (activeCountry: string, currency: string): boolean => {
    const countryCode = (activeCountry || 'DE').toUpperCase()

    return TWINT_COUNTRIES.includes(countryCode) && CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(countryCode)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
    mode,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
    mode?: string
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null

    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (
      (store?.getTwintStripeElementPayload && store.getTwintStripeElementPayload(mode)) || STIPE_ELEMENT_OPTIONS_DEFAULT
    )
  }

  getPaymentElementOptions = () => ({})
}
